import { ADD_USER as addUser } from './addUser';
import { APPLICATIONS as applications } from './applications';
import { DEVICES as devices } from './devices';
import issues from './issues';
import { MANAGE_USERS as manageUsers } from './manageUsers';

export const MANAGE = { manageUsers, applications, addUser, issues, devices };
